class SavedCardService {
    constructor(Restangular) {
        this._api = Restangular.all('SavedCards');
        this._deleteCardApi = Restangular.all('/SavedCards/DeleteSavedCards');
    }

    getSavedCard(panNumber) {
        return this._api.get(panNumber);
    }

    getSavedCards() {
        return this._api.getList();
    }

    deleteSavedCard(pan) {
        return this._deleteCardApi.post({ Pan: pan });
    }

    saveCardForOrder(orderId) {
        return this._api.post({ OrderId: orderId });
    }
}

module.exports = { SavedCardService };



// WEBPACK FOOTER //
// ./src/order/savedcard/saved-card.service.js